module.exports = __webpack_public_path__ + "static/media/empretec-2.e43d9451.jpg";